import { ToolsMenu } from './ToolsMenu'
import { CanvasTools, canvasBg, ToolRail } from './ToolRail'

const FRAMES = [
  { label: 'lookbook-01.png', src: '/images/medium-fashion.jpg', x: 370, y: 44, w: 160, h: 200, selected: false },
  { label: 'poster-04.png', src: '/images/medium-photography.jpg', x: 560, y: 44, w: 160, h: 200, selected: true },
  { label: 'set-compositor.png', src: '/images/node-compositor.jpg', x: 750, y: 44, w: 230, h: 148, selected: false },
  { label: 'moodboard-02.png', src: '/images/node-image.jpg', x: 370, y: 290, w: 160, h: 160, selected: false },
] as const

/** Artboard: frames on the canvas, the rail's tool catalogue open on Image. */
export function BoardView() {
  return (
    <div className={`absolute inset-0 ${canvasBg}`}>
      <ToolRail active={1} />
      <ToolsMenu />
      {FRAMES.map((f) => (
        <div key={f.label} className="absolute" style={{ left: f.x, top: f.y, width: f.w }}>
          <span className={`mb-1 block text-[9.5px] ${f.selected ? 'text-bone' : 'text-faint'}`}>{f.label}</span>
          <img
            src={f.src}
            alt=""
            className={`block w-full object-cover ${f.selected ? 'outline-2 outline-offset-2 outline-bone' : ''}`}
            style={{ height: f.h }}
          />
        </div>
      ))}
      <div className="absolute" style={{ left: 560, top: 290, width: 230 }}>
        <span className="mb-1 block text-[9.5px] text-faint">a brass oil lamp, warm rim light…</span>
        <div className="flex h-[160px] flex-col justify-end gap-2 bg-panel p-3 ring-1 ring-lamp">
          <span className="flex items-center justify-between text-[10px] text-muted">
            <span>Z-Image Turbo · local</span>
            <span className="num text-bone">62%</span>
          </span>
          <span className="block h-[2px] w-full bg-line">
            <span className="block h-full w-[62%] bg-lamp" />
          </span>
        </div>
      </div>
      <CanvasTools className="left-1/2" />
    </div>
  )
}
